import React from "react";
import Container from "./styled";

export default function TextButton() {
  return (
    <Container>
      {/* Title */}
      <h1 className="opacidad12">No pudimos encontrar la ruta solicitada</h1>
      {/* Text */}
      <p className="opacidad12">
        Si pensas que es un error, por favor contactanos.
      </p>
      {/* Button */}
      <a href="/" className="opacidad12">
        Inicio
      </a>
    </Container>
  );
}
